import React from "react";
import { NavDropdown } from "react-bootstrap";
import NavBarBlades from "../../../assets/blades-in-the-dark/navbar-icon-blades-in-the-dark.webp";

const sessionLinks = [
  {
    href: "/blades-in-the-dark-session-01",
    label: "01: Akoros Bay Company [01-11-2025]",
  },
  {
    href: "/blades-in-the-dark-session-00",
    label: "00: The Bog Diggers [11-30-2024]",
  },
];

const toolsAndInfoLinks = [
  { href: "/blades-in-the-dark-overview", label: "What Is Blades?" },
  { href: "/blades-in-the-dark-classes-core", label: "Classes" },
  { href: "/blades-in-the-dark-crews-core", label: "Crews" },
];

const campaignLinks = [
  {
    href: "/blades-in-the-dark-campaign-introduction",
    label: "Introduction",
  },
  { href: "/blades-in-the-dark-campaign-districts", label: "Districts" },
];

const renderLinks = (links) =>
  links.map((item) => (
    <NavDropdown.Item key={item.href} href={item.href}>
      {item.label}
    </NavDropdown.Item>
  ));

const BITDNavBar = () => {
  return (
    <NavDropdown title="Blades in the Dark" id="bitd-nav-dropdown">
      <NavDropdown.Header>
        <img
          src={NavBarBlades}
          alt="Blades in the Dark"
          style={{ maxHeight: 85 }}
        />
      </NavDropdown.Header>

      <NavDropdown title="Sessions 00-10" id="bitd-sessions-00-10">
        {renderLinks(sessionLinks)}
      </NavDropdown>

      <NavDropdown title="Tools and Info" id="bitd-tools-and-info">
        {renderLinks(toolsAndInfoLinks)}
      </NavDropdown>

      <NavDropdown title="Campaign" id="bitd-campaign">
        {renderLinks(campaignLinks)}
      </NavDropdown>
    </NavDropdown>
  );
};

export default BITDNavBar;
